import { isInvoiceItemLine } from "@common/helpers/lineItems";
import { roundToCents } from "@common/helpers/monetary";
import {
    InvoiceLineItemSchedule,
    InvoiceSchedule,
} from "@common/schemas/domains/invoice/invoice-response.schema";
import { InvoiceLineItemKind } from "@common/types/invoice";

export interface InvoiceScheduleTeardownInput {
    schedule?: InvoiceSchedule;
    lines?: Array<{
        kind: InvoiceLineItemKind;
        amount: number;
        matchedAmount: number;
        schedule?: InvoiceLineItemSchedule;
    }>;
}

export interface InvoiceScheduleTeardown {
    unscheduledOpenAmount: number;
}

export function describeInvoiceScheduleTeardown({
    invoice,
    openAmount,
}: {
    invoice: InvoiceScheduleTeardownInput;
    openAmount: number;
}): InvoiceScheduleTeardown | null {
    const itemLines = (invoice.lines ?? []).filter(isInvoiceItemLine);
    const isWholeInvoiceScheduled =
        invoice.schedule?.scope === "invoice" &&
        invoice.schedule.scheduleApplicationId !== null;
    const scheduledLines = isWholeInvoiceScheduled
        ? itemLines
        : itemLines.filter((line) => line.schedule !== undefined);
    if (!isWholeInvoiceScheduled && scheduledLines.length === 0) {
        return null;
    }
    const scheduledOpenAmount = scheduledLines.reduce(
        (total, line) => total + line.amount - line.matchedAmount,
        0,
    );
    return {
        unscheduledOpenAmount: Math.max(
            roundToCents(openAmount - scheduledOpenAmount),
            0,
        ),
    };
}
